import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import ReactGA from "react-ga4";
import MediaCard from "../components/InsightCardV2";

import { appService } from "../App/app.service";
import CustomerSuccessRoutes from "./CustomerSuccessRoutes";
import ConfifmModal from "../Favourites/ConfirmModal";
import BackdropContainer from "../components/Backdrop";
import NavItemMenuComponent from "../components/NavItemMenuComponent";

const styles = (theme) => ({
  dashOuter: {
    display: "flex",
    flexGrow: 1,
    margin: "auto",
  },
  dashInner: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  graph1: {
    flexGrow: 1,
    height: 250,
    margin: 10,
  },
});

const CustomerSuccess = (props) => {
  const [open, setOpen] = React.useState(false);
  const [charts, setCharts] = React.useState([]);
  const [confirmSignal, setConfirmSignal] = React.useState(false);
  const [selectedDashboard, setSelectedDashboard] = React.useState({});

  const baseURL = "https://skygeniwebapp.blob.core.windows.net/thumbnails/";

  // Chart metadata for Customer Success - fallback if backend doesn't provide Description/URL_for_Thumbnail
  const chartMetadata = {
    "Renewals Summary": {
      description: "Explore completed and open renewals by region, account segment over time.",
      thumbnail: "Mix Analysis.png"
    },
    "Renewals Summary - Price Increase": {
      description: "Examine completed renewals along with price increases at renewal time.",
      thumbnail: "Win Rate Analysis.png"
    },
    "Account Health - Current Status": {
      description: "Examine the current health status of accounts by region and segment.",
      thumbnail: "Mix Analysis.png"
    },
    "Account Health - Current Status": {
      description: "Examine the current health status of accounts by region and segment.",
      thumbnail: "Mix Analysis.png"
    },
    "Account Health - Change over time": {
      description: "Analyze how the health status of accounts changed over time.",
      thumbnail: "Win Rate Analysis.png"
    },
    "Account Health - By Teams": {
      description: "Delve into the health status of accounts by team and segment.",
      thumbnail: "Win Rate Analysis.png"
    },
    "Account Health - Get Well Summary": {
      description: "Analyze plans to improve the health of accounts by team and time frame.",
      thumbnail: "Win Rate Analysis.png"
    },
    "QBRs Completed": {
      description: "Explore the QBRs completed by account segment and CARR.",
      thumbnail: "Mix Analysis.png"
    },
    "Customer Churn Analysis": {
      description: "Analyze customer churn and Net Retention.",
      thumbnail: "Mix Analysis.png"
    }
  };

  const cleanAfterConfirm = () => {
    setConfirmSignal(false);
    setSelectedDashboard({});
  };

  const handleOpen = ({ dashboard_id, Chart_Name }) => {
    setSelectedDashboard({ dashboard_id, Chart_Name });
    setOpen(true);
  };

  const handleConfirmClose = () => {
    setOpen(false);
  };

  const handleClose = () => {
    setConfirmSignal(false);
    setOpen(false);
  };

  useEffect(() => {
    // Enrich charts with metadata if Description or URL_for_Thumbnail is missing
    const enrichedCharts = props.charts.map(chart => {
      const metadata = chartMetadata[chart.Chart_Name];
      console.log('Chart Name:', chart.Chart_Name);
      console.log('Metadata found:', metadata);
      console.log('Original Description:', chart.Description);
      console.log('Original Thumbnail:', chart.URL_for_Thumbnail);
      return {
        ...chart,
        Description: chart.Description || (metadata ? metadata.description : ""),
        URL_for_Thumbnail: chart.URL_for_Thumbnail || (metadata ? metadata.thumbnail : "Mix Analysis.png")
      };
    });
    console.log('Enriched charts:', enrichedCharts);
    setCharts(enrichedCharts);
  }, [props.charts]);

  useEffect(() => {
    props.getUser();
  }, []);

  const { classes } = props;

  const handleLocationChange = (loc) => {
    console.log(loc, "loc");
    props.changeCustomerSuccessPage(loc);
  };

  return (
    <NavItemMenuComponent
      location={props.location}
      isFavActionLoading={props.isFavActionLoading}
      routesComponent={
        <CustomerSuccessRoutes
          company={props.company}
          location={props.location}
        />
      }
      removeFavourite={props.removeFavourite}
      handleConfirmClose={handleConfirmClose}
      setConfirmSignal={setConfirmSignal}
      open={open}
      handleClose={handleClose}
      handleOpen={handleOpen}
      charts={charts}
      setCharts={setCharts}
      handleLocationChange={handleLocationChange}
      baseURL={baseURL}
      selectedDashboard={selectedDashboard}
      cleanAfterConfirm={cleanAfterConfirm}
      confirmSignal={confirmSignal}
      addFavourite={props.addFavourite}
    />
  );
};

const mapStateToProps = (state) => {
  const { customerSuccessPage, user, isFavActionLoading } = state.app;

  return {
    location: customerSuccessPage,
    company: user.company,
    charts: user.elements
      .filter((item) => item.navItem === "Customer Success").length > 0 ? user.elements
      .filter((item) => item.navItem === "Customer Success")[0]
      .charts.sort((a, b) => a.Sequence - b.Sequence) : [],
    isFavActionLoading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUser: () => {
    dispatch({ type: "get_user_data_request_page" });
    appService.getUser().then(
      (json) => {
        dispatch({ type: "get_user_data_success", user: json.user });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_user_data_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_user_data_failure", error });
      }
    );
  },
  addFavourite: (chartID, navItem) => {
    dispatch({
      type: "add_favourite_request",
      payload: chartID,
    });
    appService.putFavourite(chartID).then(
      (json) => {
        console.log(json);
        dispatch({ type: "add_favourite_success", json: { ...json, navItem, chartID } });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "add_favourite_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "add_favourite_failure", error });
      }
    );
  },
  removeFavourite: (chartID, navItem) => {
    dispatch({
      type: "delete_favourite_request",
      payload: chartID,
    });
    appService.deleteFavourite(chartID).then(
      (json) => {
        console.log(json);
        dispatch({
          type: "delete_favourite_success",
          json,
          payload: { dashboard_id: chartID, navItem },
        });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "delete_favourite_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "delete_favourite_failure", error });
      }
    );
  },
  changeCustomerSuccessPage: (loc) => {
    console.log("GA ->", loc);
    ReactGA.send({ hitType: "pageview", page: loc });
    dispatch({ type: "change_customerSuccessPage", loc });
    localStorage.setItem("skygeni-user-customerSuccessPage", loc);
    localStorage.removeItem("skygeni-user-repPage");
    localStorage.removeItem("skygeni-user-enhancedPage");
    localStorage.removeItem("skygeni-user-productPage");
    localStorage.removeItem("skygeni-user-SettingsPage");
  },
});

const connectedCustomerSuccess = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CustomerSuccess));

export { connectedCustomerSuccess as CustomerSuccessV2 };
export default CustomerSuccess;
